var Config = {
    LIMIT: "10",
    PERSIST_SECRET_KEY: "casitaprod11",
    ENVIRONMENT: "PRODUCTION",
    ENVIRONMENTS: {
        LOCAL: {
            API_URL: "https://api.casitatraveltrailers.com/v1",
            DOMAIN_URL: "https://app.casitatraveltrailers.com",
        },
        DEVELOPMENT: {
            API_URL: "https://api.casitatraveltrailers.com/v1",
            DOMAIN_URL: "https://app.casitatraveltrailers.com",
        },
        STAGING: {
            API_URL: "https://api.casitatraveltrailers.com/v1",
            DOMAIN_URL: "https://app.casitatraveltrailers.com",
        },
        PRODUCTION: {
            API_URL: "https://api.casitatraveltrailers.com/v1",
            DOMAIN_URL: "https://app.casitatraveltrailers.com",
        },
    },
}

Config.env = () => {
    return Config.ENVIRONMENTS[Config.ENVIRONMENT]
}

export default Config